(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/roomvo-launcher
 * -----------------------------------------------------------------------------
 * @version alpha 0.3
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("roomvo-launcher") === undefined) {
    class RoomvoLauncher extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            if (!this.dataset.storeId) return;
            const roomvoScriptTag = document.createElement("script");
            roomvoScriptTag.src = `https://cdn.roomvo.com/static/scripts/b2b/${this.dataset.storeId}.js`;
            roomvoScriptTag.async = true;
            document.head.appendChild(roomvoScriptTag);
            roomvoScriptTag.addEventListener("load", ()=>this.readyCallback());
        }
        readyCallback() {
            this.launcherButton = this.querySelector(".roomvo-launcher-button");
            if (!this.launcherButton.dataset.sku) return;
            this.activeObserver();
        }
        activeObserver() {
            new MutationObserver((mutations)=>{
                if (mutations.map((mutation)=>mutation.attributeName === "data-active")) this.activeState();
            }).observe(this.launcherButton, {
                attributes: true,
                childList: true
            });
        }
        activeState() {
            this.dataset.active = this.launcherButton.dataset.active;
        }
    }
    customElements.define("roomvo-launcher", RoomvoLauncher);
}

})();
